import React, { useState, useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { useTheme } from '../context/ThemeContext';
import { formatPrice } from '../utils/priceUtils';
import { formatNumberPersian } from '../utils/mobileUtils';
import { apiFetch } from '../utils/api';
import './PaymentResult.css';

function PaymentResult() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { isDarkMode } = useTheme();
  const orderId = searchParams.get('orderId');
  const success = searchParams.get('success') === 'true';
  const isTest = searchParams.get('test') === '1';
  const refNumber = searchParams.get('refNumber');
  const amount = searchParams.get('amount');
  const cardNumber = searchParams.get('cardNumber');
  const [paymentRef, setPaymentRef] = useState(null);

  useEffect(() => {
    if (!isTest && success && orderId) {
      fetchPaymentRef(orderId);
    }
  }, [isTest, success, orderId]);

  const fetchPaymentRef = async (id) => {
    try {
      const response = await apiFetch(`/api/payments/order/${id}`);
      if (!response.ok) return;
      const payments = await response.json();
      const completed = payments.find((p) => p.status === 'COMPLETED') || payments[0];
      if (completed?.referenceNumber) {
        setPaymentRef(completed.referenceNumber);
      }
    } catch (error) {
      console.error('Error fetching payment ref:', error);
    }
  };

  const formatAmount = (val) => (val ? formatPrice(val) : '');

  return (
    <div className={`payment-result-container ${isDarkMode ? 'dark' : ''}`}>
      <div className="payment-result-card">
        <div className={`payment-result-icon ${success ? 'success' : 'failed'}`}>
          {success ? '✓' : '✕'}
        </div>
        <h1>
          {isTest ? (success ? 'تست پرداخت موفق' : 'تست پرداخت ناموفق') : (success ? 'پرداخت با موفقیت انجام شد' : 'پرداخت ناموفق')}
        </h1>
        <p className="payment-result-message">
          {isTest
            ? (success ? 'تراکنش تستی با موفقیت انجام شد. هیچ سفارشی ثبت نشده است.' : 'تراکنش تستی انجام نشد یا با خطا مواجه شد.')
            : (success
              ? 'ممنونیم از خریدتون. تا ۲۴ ساعت آینده باهاتون تماس خواهیم گرفت.'
              : 'پرداخت انجام نشد یا با خطا مواجه شد. در صورت کسر مبلغ، ظرف ۷۲ ساعت به حساب شما برگردانده می‌شود.')}
        </p>
        {isTest && success && (refNumber || amount || cardNumber) && (
          <div className="payment-result-details">
            {refNumber && <p>شناسه مرجع: <strong>{refNumber}</strong></p>}
            {amount && <p>مبلغ: <strong>{formatAmount(amount)}</strong></p>}
            {cardNumber && <p>کارت: <strong>{cardNumber}</strong></p>}
          </div>
        )}
        {isTest && !success && (
          <div className="payment-result-details">
            <p>پرداخت تکمیل نشد، لغو شد یا توسط درگاه رد شد.</p>
          </div>
        )}
        {!isTest && success && orderId && (
          <div className="payment-result-details">
            <p>شماره سفارش: <strong>#{formatNumberPersian(orderId)}</strong></p>
            {paymentRef && (
              <p>کد پیگیری پرداخت: <strong>{formatNumberPersian(paymentRef)}</strong></p>
            )}
          </div>
        )}
        {!isTest && !success && orderId && (
          <p className="payment-result-order">
            شماره سفارش: <strong>#{formatNumberPersian(orderId)}</strong>
          </p>
        )}
        <div className="payment-result-actions">
          {isTest ? (
            <button
              type="button"
              className="btn-to-invoice"
              onClick={() => navigate('/dashboard', { state: { activeTab: 'gatewayTest' } })}
            >
              بازگشت به داشبورد (تست درگاه)
            </button>
          ) : (
            <>
              <button type="button" className="btn-to-cart" onClick={() => navigate('/cart')}>
                بازگشت به سبد خرید
              </button>
              {orderId && (
                <button type="button" className="btn-to-invoice" onClick={() => navigate(`/invoice/${orderId}`)}>
                  مشاهده وضعیت سفارش
                </button>
              )}
              <button type="button" className="btn-to-home" onClick={() => navigate('/')}>
                بازگشت به فروشگاه
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default PaymentResult;
